var CONFUSEDCMS = CONFUSEDCMS || {},
    CONFUSEDPARKINGAPP = CONFUSEDPARKINGAPP || {};

(function () {
    'use strict';

    CONFUSEDPARKINGAPP.submitFilter = function (parkingFilter) {

        CONFUSEDPARKINGAPP.submitPageEvent({
            EventType: 'parkingapp:filter:clicked',
            EventInfo: {
                'SpacesAvailable': parkingFilter.SpacesAvailable(),
                'ShortTerm': parkingFilter.ShortTerm(),
                'LongTerm': parkingFilter.LongTerm(),
                'AllocatedSpace': parkingFilter.AllocatedSpace(),
                'ShelteredParking': parkingFilter.ShelteredParking(),
                'Garage': parkingFilter.Garage(),
                'TwentyFourSevenAccess': parkingFilter.TwentyFourSevenAccess(),
                'SecurityGates': parkingFilter.SecurityGates(),
                'AirportTransfers': parkingFilter.AirportTransfers()
            }
        });
    };

    CONFUSEDPARKINGAPP.submitClickthrough = function (clickthroughUrl, id, priceHourly, priceDaily, priceMonthly, distance, source) {

        CONFUSEDPARKINGAPP.submitPageEvent({
            EventType: 'parkingapp:clickthrough:clicked',
            EventInfo: {
                'ClickthroughUrl': clickthroughUrl,
                'SpaceId': id,
                'PriceHourly': priceHourly,
                'PriceDaily': priceDaily,
                'PriceMonthly': priceMonthly,
                'DistanceInMiles': distance,
                'Source': source
            }
        });
    };

    CONFUSEDPARKINGAPP.submitDisplayLimit = function (searchAddress, googlePlaceId, numberOfParkingSpace, maxNumberOfParkingSpaces, distanceOfParkingSpace, maxDistanceOfParkingSpaces) {

        CONFUSEDPARKINGAPP.submitPageEvent({
            EventType: 'parkingapp:displaylimit:applied',
            EventInfo: {
                'SearchAddress': searchAddress,
                'GooglePlaceId': googlePlaceId,
                'NumberOfParkingSpace': numberOfParkingSpace,
                'MaxNumberOfParkingSpaces': maxNumberOfParkingSpaces,
                'DistanceOfParkingSpace': distanceOfParkingSpace,
                'MaxDistanceOfParkingSpaces': maxDistanceOfParkingSpaces
            }
        });
    };

    CONFUSEDPARKINGAPP.submitCurrentPosition = function (positionLatitude, positionLongitude, searchAddress, googlePlaceId) {

        CONFUSEDPARKINGAPP.submitPageEvent({
            EventType: 'parkingapp:currentposition:clicked',
            EventInfo: {
                'PositionLatitude': positionLatitude,
                'PositionLongitude': positionLongitude,
                'SearchAddress': searchAddress,
                'GooglePlaceId': googlePlaceId
            }
        });
    };

    CONFUSEDPARKINGAPP.submitPageEvent = function (eventInfo) {
        CONFUSEDCMS.services.MiService().pageEvent(eventInfo);
    };

}());